import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-002dd054"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "card bg-light mb-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-plus me-2" }),
  /*#__PURE__*/_createTextVNode("เพิ่ม ร.นรม./รมต.นร. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-arrows-alt me-2" }, null, -1))
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "no-bullets" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-tie me-2" }, null, -1))
const _hoisted_12 = { class: "d-flex justify-content-start wraper" }
const _hoisted_13 = {
  key: 0,
  class: "col-auto d-flex align-items-center"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-edit me-2" }, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "col-md-4 col-xl-3"
}
const _hoisted_17 = { class: "card bg-light" }
const _hoisted_18 = { class: "card-header" }
const _hoisted_19 = { class: "input-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-search" })
], -1))
const _hoisted_21 = { class: "card-body p-0" }
const _hoisted_22 = { class: "list-group list-group-flush" }
const _hoisted_23 = {
  key: 0,
  class: "list-group-item bg-light text-center text-danger"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }, null, -1))
const _hoisted_25 = ["data-bs-content"]
const _hoisted_26 = ["onDragstart"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-tie mx-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_PerfectScrollbar = _resolveComponent("PerfectScrollbar")!
  const _component_CabinetMinisterFormComponent = _resolveComponent("CabinetMinisterFormComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass({'col-md-8 col-xl-9': _ctx.cabinetStatus === 0})
      }, [
        (_ctx.cabinetStatus === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", {
                class: _normalizeClass(["card-body p-3 dropzone d-flex justify-content-center align-items-center", {drag: _ctx.isDrag}]),
                onDragover: _cache[0] || (_cache[0] = ($event: any) => ($event.preventDefault())),
                onDrop: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["stop","prevent"]))
              }, [
                _hoisted_4,
                _createTextVNode("กรุณาลากชื่อ ร.นรม./รมต.นร. ด้านขวามือมาที่นี่ ")
              ], 34)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
            : (_openBlock(), _createBlock(_component_Draggable, _mergeProps({
                key: 1,
                list: _ctx.cabinetMinisters,
                disabled: !_ctx.enabled,
                "item-key": "sequence",
                class: "no-bullets",
                tag: "ul"
              }, _ctx.dragOptions, {
                "ghost-class": "ghost",
                onStart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dragging = true)),
                onEnd: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dragging = false)),
                onChange: _ctx.onMoved
              }), {
                item: _withCtx(({ element }) => [
                  _createElementVNode("li", {
                    class: _normalizeClass({ 'not-draggable': !_ctx.enabled, 'draggable': _ctx.enabled })
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["card card-minister my-2", {'card-minister-active': _ctx.cabinetStatus === 0}])
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("img", {
                              class: "photo-image",
                              src: element.minister.photo,
                              width: "60",
                              height: "70",
                              alt: "preview"
                            }, null, 8, _hoisted_8)
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("ul", _hoisted_10, [
                              _createElementVNode("li", null, [
                                _hoisted_11,
                                _createTextVNode(_toDisplayString(element.minister.fullName), 1)
                              ]),
                              _createElementVNode("li", null, _toDisplayString(element.position.name), 1),
                              _createElementVNode("li", null, [
                                _createElementVNode("div", _hoisted_12, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.regions, (region) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      class: "badge bg-primary rounded-pill mt-1 me-1",
                                      key: region.id
                                    }, _toDisplayString(region.shortName), 1))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]),
                          (_ctx.cabinetStatus === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("button", {
                                  class: "btn minister-edit-btn",
                                  onClick: ($event: any) => (_ctx.editClick(element.id))
                                }, [
                                  _hoisted_15,
                                  _createTextVNode("แก้ไข ")
                                ], 8, _hoisted_14)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 2)
                  ], 2)
                ]),
                _: 1
              }, 16, ["list", "disabled", "onChange"]))
        ])
      ], 2),
      (_ctx.cabinetStatus === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    "aria-label": "Search",
                    autocomplete: "off",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filter.keyword) = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.filter.keyword,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_PerfectScrollbar, null, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_22, [
                      (_ctx.search.length === 0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                            _hoisted_24,
                            _createTextVNode("ไม่พบข้อมูล ")
                          ]))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.search, (minister, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index,
                              class: _normalizeClass(["list-group-item p-0", {'ghost-minister': _ctx.dragElement === minister.id}]),
                              "data-bs-toggle": "popover-minister",
                              "data-bs-content": _ctx.popPhoto(minister.photo)
                            }, [
                              _createElementVNode("div", {
                                class: "draggable text-truncate p-3",
                                draggable: "true",
                                onDragstart: ($event: any) => (_ctx.onDragStart($event, minister.id.toString())),
                                onDragend: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onDragEnd && _ctx.onDragEnd(...args)))
                              }, [
                                _hoisted_27,
                                _createTextVNode(_toDisplayString(minister.fullName), 1)
                              ], 40, _hoisted_26)
                            ], 10, _hoisted_25))
                          }), 128))
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_CabinetMinisterFormComponent, {
      ref: "cabinetMinisterForm",
      "cabinet-minister": _ctx.selectedCabinetMinister,
      onClear: _ctx.clearSelectedCabinetMinister
    }, null, 8, ["cabinet-minister", "onClear"])
  ], 64))
}